<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form" v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="uniformStatus"
              :items="uniformStatuses"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Trạng thái hoạt động"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4" v-show="false">
            <CheckboxAcademicLevel :isDefaultCheckAll="false" @change="academicLevelChanged" />
          </v-col>
        </v-row>
        <v-row class="pt-4">
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="name"
              clear-icon="mdi-close"
              label="Tên đồng phục"
              flat
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckboxAcademicLevel from '@/modules/academicLevel/CheckboxAcademicLevel.vue'
import { textHelpers } from '@/helpers/TextHelper'
export default {
  components: {
    CheckboxAcademicLevel
  },
  data: () => ({
    uniformStatus: '',
    academicLevels: [],
    name: '',
  }),
  computed: {
    ...mapGetters('constant', ['uniformStatuses']),
  },
  methods: {
    academicLevelChanged(academicLevels) {
      this.academicLevels = academicLevels
    },
    onFilterChanged() {
      if (!this.$refs.form.validate()) return
      const params = {
        activeStatus: this.uniformStatus,
        academicLevel_in: this.academicLevels.map(a => a.id),
        name_contains: textHelpers.removeSpaces(this.name),
      }
      this.$emit('onFilterChanged', params)
    }
  },
  created() {
    // const { date } = this.$route.query
    // if (date) {
    //   this.currentDate = date
    // }
  },
  mounted() {
    this.onFilterChanged()
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
